import React, { useState } from 'react';
import { generateProfilePictureUrl } from '../../../../constants/AppConstants';

interface ProfilePictureProps {
  loginName: string;
  name: string;
  size?: 'small' | 'medium' | 'large';
}

export const ProfilePicture: React.FC<ProfilePictureProps> = ({ loginName, name, size = 'medium' }) => {
  const [imageError, setImageError] = useState(false);

  const sizeStyles = {
    small: { width: '32px', height: '32px' },
    medium: { width: '48px', height: '48px' },
    large: { width: '64px', height: '64px' }
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const getInitials = (fullName: string): string => {
    return fullName
      .split(' ')
      .map((name) => name.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  if (imageError || !loginName) {
    // Fallback to initials
    return (
      <div
        style={{
          ...sizeStyles[size],
          backgroundColor: '#e3f2fd',
          border: '2px solid #2196f3',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size === 'small' ? '12px' : size === 'medium' ? '14px' : '18px',
          fontWeight: 'bold',
          color: '#1976d2',
          boxSizing: 'border-box',
          flexShrink: 0,
          overflow: 'hidden',
          minWidth: sizeStyles[size].width,
          minHeight: sizeStyles[size].height,
          maxWidth: sizeStyles[size].width,
          maxHeight: sizeStyles[size].height,
          aspectRatio: '1 / 1'
        }}
      >
        {getInitials(name)}
      </div>
    );
  }

  return (
    <img
      src={generateProfilePictureUrl(loginName)}
      alt={`${name} profile`}
      style={{
        ...sizeStyles[size],
        borderRadius: '50%',
        border: '2px solid #e0e0e0',
        objectFit: 'cover',
        boxSizing: 'border-box',
        flexShrink: 0,
        display: 'block',
        minWidth: sizeStyles[size].width,
        minHeight: sizeStyles[size].height,
        maxWidth: sizeStyles[size].width,
        maxHeight: sizeStyles[size].height
      }}
      onError={handleImageError}
    />
  );
};
